import {InsightsFeature, RegistryFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';

export function isEmbeddingEnabled(): boolean {
  return isFeatureEnabled({feature: InsightsFeature.INSIGHTS_DISCOVER});
}

export function isRegistryEmbeddingEnabled(): boolean {
  return isEmbeddingEnabled() && isFeatureEnabled({feature: RegistryFeature.REGISTRY_OPEN});
}
